export default __webpack_public_path__ + "static/media/madurai2.d60b8b27.jpg";